import { gsap } from "gsap";

class NewsMore {
  constructor(el) {
    this.dom = {el: el};
    this.moreTarget = document.querySelectorAll('[data-display="none"]');

    this.show = this.show.bind(this);

    this.init();
  }

  init() {
    this.dom.el.addEventListener('click', this.show);
  }

  show() {
    [...this.moreTarget].forEach(el=>{
      gsap.to(el, {
        display: 'block',
        opacity: 1,
        y: 0,
        duration: 1.2
      })
    })
    this.dom.el.style.display = 'none';
  }
}

export default NewsMore